// extracted by mini-css-extract-plugin
module.exports = {"Container":"Polynomial_Container__1_sCR","Variable":"Polynomial_Variable__1aO7y","Img":"Polynomial_Img__wbIAE"};